import { render, staticRenderFns } from "./GalleryVideosItem.vue?vue&type=template&id=3a8fd830"
import script from "./GalleryVideosItem.vue?vue&type=script&lang=js"
export * from "./GalleryVideosItem.vue?vue&type=script&lang=js"
import style0 from "./GalleryVideosItem.vue?vue&type=style&index=0&id=3a8fd830&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports